import {
  Dispatch,
  SetStateAction,
  useContext,
  useState as classicUseState,
} from 'react';
import { GlobalMenu } from '@components';
import { StateMethods } from '@hookstate/core';
import { ITag } from '@models/Tag.model';
import { NavigationContext } from '@layout/navigation/navigation';
import { InviteUserRole } from '@models/Invite.model';
import { Container, Divider } from './TagsMenu.styles';
import { EditTagDialog } from './Components/EditTagDialog/EditTagDialog';

interface ITagsMenu {
  setOpenMoveTagDialog: Dispatch<SetStateAction<boolean>>;
  setTagId: Dispatch<SetStateAction<string[]>>;
  openDeleteTagDialog: StateMethods<boolean>;
  tags: ITag;
}

const TagsMenu = ({
  setOpenMoveTagDialog,
  openDeleteTagDialog,
  setTagId,
  tags,
}: ITagsMenu) => {
  const [openEditTagDialog, setOpenEditTagDialog] =
    classicUseState<boolean>(false);

  const { role } = useContext(NavigationContext);

  return (
    <Container>
      <GlobalMenu
        align="end"
        title="Options"
        paddingTop="6px"
        itemList={[
          {
            disabled: ![InviteUserRole.ADMIN, InviteUserRole.EDITOR].includes(
              role,
            ),
            disableToolTip: [
              InviteUserRole.ADMIN,
              InviteUserRole.EDITOR,
            ].includes(role),
            toolTipText: 'Only Admins or Editors can edit a tag',
            toolTipId: 'editTagTooltip',
            label: 'Edit',
            iconName: 'edit',
            onClick: () => {
              setOpenEditTagDialog(true);
            },
          },
          {
            disabled: ![InviteUserRole.ADMIN, InviteUserRole.EDITOR].includes(
              role,
            ),
            disableToolTip: [
              InviteUserRole.ADMIN,
              InviteUserRole.EDITOR,
            ].includes(role),
            toolTipText: 'Only Admins or Editors can move a tag',
            toolTipId: 'moveTagTooltip',
            label: 'Move',
            iconName: 'add-to-folder',
            onClick: () => {
              setOpenMoveTagDialog(true);
              setTagId([tags.id]);
            },
          },
          {
            disabled: ![InviteUserRole.ADMIN, InviteUserRole.EDITOR].includes(
              role,
            ),
            disableToolTip: [
              InviteUserRole.ADMIN,
              InviteUserRole.EDITOR,
            ].includes(role),
            toolTipText: 'Only Admins or Editors can delete a tag',
            toolTipId: 'deleteTagTooltip',
            label: 'Delete',
            iconName: 'trash',
            onClick: () => {
              openDeleteTagDialog.set(true);
              setTagId([tags.id]);
            },
          },
        ]}
      />

      <Divider height="6px" />

      {openEditTagDialog && (
        <EditTagDialog
          tagId={tags}
          open={openEditTagDialog}
          onClose={() => {
            setOpenEditTagDialog(false);
          }}
        />
      )}
    </Container>
  );
};

export { TagsMenu };
